<template>
  <div class="jclist-page">
    <section class="content">
      <p class="content-text">请选择检测版本</p>
      <ul class="top-select">
        <li
          v-for="list in navList"
          :class="list.id == isSelect ? 'lis ov' : 'lis ot'"
          :key="list.id"
          @click="toChooese(list)"
        >
          <div class="libtm">
            <p class="top-icons">
              <img :src="getCategoryIcon(list)" class="isimgs" />
            </p>
            <p :class="list.id == isSelect ? 'top-text' : ''">
              <span style="font-size: 0.37rem">{{ list.sname }}</span>
            </p>
          </div>
          <div :class="list.id == isSelect ? 'des' : 'desc'">
            <p style="height: 100%; width: 100%">
              <span style="font-size: 0.25rem">{{ list.tese }}</span>
            </p>
          </div>
          <div class="icon-yes" v-if="list.id == isSelect">
            <img src="../assets/img/index_icon_yes.png" class="show" />
          </div>
        </li>
      </ul>
    </section>

    <div class="btn-wrap">
      <van-button
        color="#228ef7"
        block
        class="btn"
        @click="toCheck(isSelect, banben, price, pricetype, desc, cid)"
      >
        <span style="font-size: 0.37rem">提交检测</span>
      </van-button>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import {
  getAllCategories,
  getCategoryPrice,
  getPriceUnitSuffix,
} from "@/utils/order";
export default {
  data() {
    return {
      edtion: {
        isyes: require("../assets/img/index_icon_yes.png"),
        chooseOt: require("../assets/img/index_icon1_ot.png"),
        chooseOv: require("../assets/img/index_icon1_ov.png"),
      },
      navList: [],
      isSelect: "",
      desc: "",
      pricetype: "",
      price: "",
      banben: "",
      cid: "",
      ids: "",
      wxdev: false,
      uservalue: "",
      oldPrice: "",
      allCategories: [],
    };
  },
  created() {
    let storageData = JSON.parse(window.sessionStorage.getItem("user"));
    if (storageData) {
      this.uservalue = storageData.user_group;
    }
    this.getData();
  },
  filters: {
    filterPrice: function (value) {
      return getPriceUnitSuffix(value);
    },
  },
  methods: {
  getCategoryIcon(item) {
    if (!item || !item.id) {
      return item && item.sys_logo ? item.sys_logo : "";
    }

    const suffix = item.id == this.isSelect ? "b" : "a";
    return `https://www.wanfangtest.com/asset/images/icon/${item.id}${suffix}.png`;
  },
  toCheck(id, banben, price, pricetype, desc, cid) {
    if (window.sessionStorage.getItem("Token")) {
      this.$router.push({
        path: "/ccpage",
        query: {
          id: id,
          banben: banben,
          price: price,
          pricetype: pricetype,
          desc: desc,
          cid: cid,
        },
      });
    } else {
      // 自定义弹窗
      Dialog({
        title: "",
        message: `<div style="text-align: center; position: relative; max-height: 80vh; overflow: hidden; white-space: normal;"><div id="closeDialogBtn" style="position: absolute; top: 0px; right: 0px; cursor: pointer; font-size: 20px; color: #999; width: 26px; height: 26px; display: flex; align-items: center; justify-content: center; z-index: 10;">×</div><div style="margin-bottom: 12px;"><img src="${require("../assets/img/logo.jpg")}" alt="Logo" style="width: 100px; height: 100px; border-radius: 50%; object-fit: cover; border: 2px solid #f0f0f0;"></div><div style="margin-bottom: 18px; font-size: 16px; line-height: 1.5; color: #333; text-align: left;">因浏览器限制,无法查看论文检测进度;<br>为方便查收检测报告,请在微信小程序内提交。</div><div style="display: flex; flex-direction: column; gap: 10px; align-items: center;"><button id="openMiniProgramBtn" style="width: 200px; height: 40px; background: #07c160; color: white; border: none; border-radius: 20px; font-size: 16px; cursor: pointer; box-shadow: 0 2px 6px rgba(7, 193, 96, 0.3);">打开微信小程序</button><button id="continueLoginBtn" style="width: 200px; height: 40px; background: #eee; color: #999; border: 1px solid #ddd; border-radius: 20px; font-size: 16px; cursor: pointer;">继续网页登录</button></div></div>`,
        width: "85%",
        allowHtml: true,
        showConfirmButton: false,
        showCancelButton: false,
        closeOnClickOverlay: true,
      });

      // 绑定按钮事件
      setTimeout(() => {
        // 关闭按钮
        const closeBtn = document.getElementById('closeDialogBtn');
        if (closeBtn) {
          closeBtn.onclick = () => {
            Dialog.close();
          };
        }

        // 打开小程序按钮
        const openBtn = document.getElementById('openMiniProgramBtn');
        if (openBtn) {
          openBtn.onclick = () => {
            try {
              window.location.href = "weixin://dl/business/?appid=wx346def384ee887a2&path=pages/index/index&query=wxfrom=baidu";
              Dialog.close();
            } catch (error) {
              console.log("无法打开微信小程序:", error);
              Dialog.close();
              Dialog.alert({
                title: "提示",
                message: "请在微信搜一搜'万方论文检测'使用小程序"
              });
            }
          };
        }

        // 继续登录按钮
        const loginBtn = document.getElementById('continueLoginBtn');
        if (loginBtn) {
          loginBtn.onclick = () => {
            Dialog.close();
            const ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              this.$router.push({
                path: "/blankpage",
                query: {
                  currentpath: "/jcsystem",
              },
            });
          } else {
              this.$router.push("/Login");
            }
          };
        }
      }, 100);
    }
  },
    toChooese(item) {
      this.isSelect = item.id;
      this.desc = item.intro;
      this.pricetype = item.price_type;
      this.oldPrice = item.price;
      this.price = getCategoryPrice(item, this.uservalue);
      this.banben = item.name;
      this.cid = item.cid;
    },
    getData() {
      this.$http.getjcList().then((res) => {
        const categories = getAllCategories(res);
        this.allCategories = categories;
        this.navList = categories;

        if (!categories.length) {
          return;
        }

        this.toChooese(categories[0]);
      });
    },
  },
};
</script>

<style  scoped>
.icon {
  line-height: 0.8rem;
  font-size: 0.48rem;
  width: 11%;
}
.title span {
  line-height: 0.8rem;
  width: 85%;
  font-size: 0.3rem;
  text-align: center;
}
.top-select {
  padding: 0 0.3rem 0;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.ot {
  border: 1px solid #c7c7c7;
}
.lis {
  width: 3.3rem;
  height: 1.4rem;
  border-radius: 0.1rem;
  position: relative;
  margin-bottom: 0.2rem;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.ov {
  border: 1px solid #f5602a;
}

.isimgs {
  background-position: 0% 0%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.libtm {
  height: 0.85rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 0.37rem;
}
.top-icons {
  width: 0.8rem;
  height: 0.8rem;
  display: inline-block;
  overflow: hidden;
  position: relative;
  padding-right: 0.07rem;
}

.top-text {
  color: #f5602a;
}
.des {
  color: #e37a55;
  background: #fff5f2;
  width: 100%;
  padding: 0 6px;
  font-size: 15px;
  height: 0.49rem;
  line-height: 0.49ren;
  line-height: 0.49rem;
}
.desc {
  color: #999;
  background: #f7f8f9;
  width: 100%;
  padding: 0 6px;
  font-size: 15px;
  height: 0.49rem;
  line-height: 0.49rem;
}

.content {
  background: #fff;
  padding-bottom: 0.3rem;
  border-bottom: 0.5px #d9d9d9 solid;
}
.jclist-page {
  padding-bottom: calc(1.9rem + env(safe-area-inset-bottom));
}
.content-text {
  padding: 0 0.3rem;
  font-size: 0.3rem;
  color: #999;
  height: 0.9rem;
  line-height: 0.9rem;
}
.icon-yes {
  position: absolute;
  right: 0rem;
  top: 0rem;
  width: 0.5rem;
  height: 0.7rem;
}
.show {
  width: 100%;
  height: 100%;
}
.bbtext {
  padding: 0.3rem 0.3rem 0;
  font-size: 0.3rem;
  color: #666;
}
.bbcontent {
  margin-top: 0.4rem;
}
.shuoming {
  padding: 0.3rem 0.3rem 0;
  font-size: 0.3rem;
  line-height: 0.5rem;
  color: #999;
}
.btn-wrap {
  position: sticky;
  bottom: calc(1.05rem + env(safe-area-inset-bottom));
  z-index: 20;
  padding: 0.24rem 0.28rem 0;
  background: linear-gradient(180deg, rgba(245, 247, 250, 0) 0%, #f5f7fa 45%, #f5f7fa 100%);
}
.btn {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 0.37rem;
  border-radius: 0.18rem;
  box-shadow: 0 0.12rem 0.28rem rgba(34, 142, 247, 0.2);
}
.petty {
  font-size: 0.28rem;
  color: #999;
  text-align: center;
  padding: 25px 0;
}
</style>
